import { render, staticRenderFns } from "./cl-download-tip.vue?vue&type=template&id=6e2a4b96&scoped=true"
import script from "./cl-download-tip.vue?vue&type=script&lang=js"
export * from "./cl-download-tip.vue?vue&type=script&lang=js"
import style0 from "./cl-download-tip.vue?vue&type=style&index=0&id=6e2a4b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2a4b96",
  null
  
)

export default component.exports